import GATSBY_COMPILED_MDX from "/home/runner/work/klittlepage.com/klittlepage.com/src/articles/2013-12-15-twelve-days-2013-domain-specific-search-and-sort.mdx";
import * as React from 'react';
import {navigate} from 'gatsby';
import {MDXProvider} from '@mdx-js/react';
import {useIsMounted} from 'usehooks-ts';
import {Container} from '@/components/Container';
import {Head as BaseHead, Layout} from '@/components/Layout';
import {Link} from '@/components/Link';
import {BlogArticleMetadata} from '@/components/Metadata';
import {ArrowLeftIcon} from '@/components/NavIcons';
import {formatDate} from '@/lib/formatDate';
import {Prose} from '@/components/Prose';
import {PrismSyntaxHighlight} from '@/components/SyntaxHighlighter';
export const ArticleLayout = _ref => {
  let {children, pageContext, ...props} = _ref;
  const isMounted = useIsMounted();
  const [hasHistory, setHasHistory] = React.useState(false);
  React.useEffect(() => {
    setHasHistory(typeof history !== "undefined" ? history.length > 0 : false);
  }, [isMounted]);
  const {frontmatter: {title, date}} = pageContext;
  return React.createElement(Layout, Object.assign({
    pageContext: pageContext
  }, props), React.createElement(Container, {
    className: "mt-16 lg:mt-32"
  }, React.createElement("div", {
    className: "xl:relative"
  }, React.createElement("div", {
    className: "mx-auto max-w-2xl"
  }, hasHistory && React.createElement("button", {
    type: "button",
    onClick: () => void navigate(-1),
    "aria-label": "Go back to articles",
    className: "group mb-8 flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-md shadow-zinc-800/5 ring-1 ring-zinc-900/5 transition dark:border dark:border-zinc-700/50 dark:bg-zinc-800 dark:ring-0 dark:ring-white/10 dark:hover:border-zinc-700 dark:hover:ring-white/20 lg:absolute lg:-left-5 lg:mb-0 lg:-mt-2 xl:-top-1.5 xl:left-0 xl:mt-0"
  }, React.createElement(ArrowLeftIcon, {
    className: "h-4 w-4 stroke-zinc-500 transition group-hover:stroke-zinc-700 dark:stroke-zinc-500 dark:group-hover:stroke-zinc-400"
  })), React.createElement("article", null, React.createElement("header", {
    className: "flex flex-col"
  }, React.createElement("h1", {
    className: "mt-6 text-4xl font-bold tracking-tight text-zinc-800 dark:text-zinc-100 sm:text-5xl"
  }, title), React.createElement("time", {
    dateTime: date,
    className: "order-first flex items-center text-base text-zinc-400 dark:text-zinc-500"
  }, React.createElement("span", {
    className: "h-4 w-0.5 rounded-full bg-zinc-200 dark:bg-zinc-500"
  }), React.createElement("span", {
    className: "ml-3"
  }, formatDate(date)))), React.createElement(Prose, {
    className: "mt-8"
  }, React.createElement(MDXProvider, {
    components: {
      a: _ref2 => {
        let {ref, href: to, ...props} = _ref2;
        return React.createElement(Link, Object.assign({
          to: to || ''
        }, props));
      },
      code: _ref3 => {
        let {children, className} = _ref3;
        return className ? React.createElement(PrismSyntaxHighlight, {
          className: className
        }, children) : React.createElement("code", null, children);
      }
    }
  }, children)))))));
};
ArticleLayout
export default function GatsbyMDXWrapper(props) {
  return React.createElement(ArticleLayout, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = _ref4 => {
  let {pageContext: {frontmatter, author, imageURL, ...pageContext}, data, ...rest} = _ref4;
  const {title, description} = frontmatter;
  const {name: authorName, githubUsername, linkedinUsername, twitterUsername} = author;
  const baseUrl = data.site.siteMetadata.siteUrl;
  const articleUrl = new URL(rest.location.pathname, baseUrl).href;
  return React.createElement(React.Fragment, null, React.createElement(BaseHead, Object.assign({
    title: title,
    description: description,
    author: authorName,
    githubUsername: githubUsername,
    linkedinUsername: linkedinUsername,
    twitterUsername: twitterUsername,
    image: imageURL ? new URL(imageURL, baseUrl).href : undefined,
    pageContext: pageContext,
    data: data
  }, rest)), React.createElement(BlogArticleMetadata, {
    siteUrl: baseUrl,
    canonicalUrl: articleUrl,
    frontmatter: frontmatter,
    author: author
  }));
};
const query = "1228583347";
